import React, { useEffect, useState } from 'react';
import { useI18n } from '../i18n/I18nProvider';
import { getTelemetryThresholds, updateTelemetryThresholds, refreshThresholds } from '../services/settingsService';

const SettingsPage = () => {
  const { t, languages, lang, setLang } = useI18n();
  const [batteryV, setBatteryV] = useState('11');
  const [saving, setSaving] = useState(false);
  const [fillGreen, setFillGreen] = useState('70');
  const [fillRed, setFillRed] = useState('90');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('info');

  useEffect(() => {
    (async () => {
      try {
        const th = await getTelemetryThresholds();
        setBatteryV(String(th.battery_low_threshold_v ?? 11));
        setFillGreen(th.fill_green_threshold_pct != null ? String(th.fill_green_threshold_pct) : '70');
        setFillRed(th.fill_red_threshold_pct != null ? String(th.fill_red_threshold_pct) : '90');
      } catch {}
    })();
  }, []);

  return (
  <div className="sb-page">
      <div style={{ maxWidth: 400 }}>
        <label htmlFor="language" style={{ display: 'block', fontWeight: 600, marginBottom: 4 }} title={t('settings.selectLanguage') || 'Válassz nyelvet.'}>{t('settings.language')}</label>
        <select
          id="language"
          value={lang}
          onChange={(e) => setLang(e.target.value)}
          className="form-control"
          style={{ marginBottom: '12px' }}
        >
          {languages.map(l => (
            <option key={l.code} value={l.code}>{l.flag ? (l.flag + ' ') : ''}{l.label}</option>
          ))}
        </select>
        {/* Hint moved to tooltip */}
      </div>
      <div style={{ maxWidth: 420, marginTop: 20 }}>
        <label htmlFor="batteryV" style={{ display: 'block', fontWeight: 600, marginBottom: 4 }} title={t('settings.batteryLowThresholdHint') || 'A térképen látható akkumulátor ikon megjelenése ehhez a küszöbhöz igazodik.'}>{t('settings.batteryLowThreshold') || 'Akkumulátor alacsony küszöb (V)'}</label>
        <input id="batteryV" type="number" step="0.1" min="6" max="20" value={batteryV}
          onChange={(e)=> setBatteryV(e.target.value)} className="form-control" style={{ marginBottom: 8 }} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 12 }}>
          <div>
            <label htmlFor="fillGreen" style={{ display: 'block', fontWeight: 600, marginBottom: 4 }} title={t('settings.fillThresholdsHint') || 'A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.'}>{t('settings.fillGreenThreshold') || 'Telítettség zöld küszöb (%)'}</label>
            <input id="fillGreen" type="number" min="0" max="100" value={fillGreen}
              onChange={(e)=> setFillGreen(e.target.value)} className="form-control" />
          </div>
          <div>
            <label htmlFor="fillRed" style={{ display: 'block', fontWeight: 600, marginBottom: 4 }} title={t('settings.fillThresholdsHint') || 'A telítettség színei (zöld/sárga/piros) ezekhez a küszöbökhöz igazodnak.'}>{t('settings.fillRedThreshold') || 'Telítettség piros küszöb (%)'}</label>
            <input id="fillRed" type="number" min="0" max="100" value={fillRed}
              onChange={(e)=> setFillRed(e.target.value)} className="form-control" />
          </div>
        </div>
        <button type="button" className="btn" disabled={saving} onClick={async ()=>{
          setSaving(true);
          try{
            const num = parseFloat(batteryV);
            const payload = {
              battery_low_threshold_v: num,
              fill_green_threshold_pct: fillGreen !== '' ? Number(fillGreen) : undefined,
              fill_red_threshold_pct: fillRed !== '' ? Number(fillRed) : undefined,
            };
            await updateTelemetryThresholds(payload);
            await refreshThresholds();
            setMessage(t('settings.saved') || 'Beállítások mentve');
            setMessageType('success');
          } catch(e){ console.error(e); } finally { setSaving(false); }
        }} style={{ marginTop: 12, padding: '6px 12px' }}>{saving ? (t('common.saving') || 'Mentés...') : (t('common.save') || 'Mentés')}</button>
        {/* Hints moved to tooltips on labels */}
      </div>
      {message && <div className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'error' ? 'danger' : 'info'}`} style={{ marginTop: 12 }}>{message}</div>}
    </div>
  );
};

export default SettingsPage;
